(function () {
  function DIEnrollment() {
    "use strict";

    var context = this;
    var mainScope = window.DI;
    context.name = "Enrollment";
    context.svgLoaderIcon = '<svg width="15" height="15" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#222" class="st-bds_svg-loader"><g fill="none" fill-rule="evenodd"><g transform="translate(1 1)" stroke-width="2"><circle stroke-opacity=".5" cx="18" cy="18" r="18"></circle><path d="M36 18c0-9.94-8.06-18-18-18"><animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite"></animateTransform></path></g></g></svg>';

    context.init = function () {
      context.endpoint = window.DI.CompanyStatic.ApiMethod;
      mainScope.DI.subscribeDOMLoaded(function () {

      });
    };
    context.GetStates = function(countryCode){
      return $.ajax({
        url: context.endpoint["CommonSettings"]["GetStates"] + `?countryCode=${countryCode}`,
        type: "GET",
        dataType: "json",
        contentType: "application/json; charset=utf-8"
      })
    }
    context.verifyusername = function (username) {
      return $.ajax({
        url: "https://casync.connectolive.com/verify/username/" + username,
        type: "GET",
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function (response) {
          if (response) {
            var data = response.Data;
          }
        },
        error: function (error) {
        }
      });
    };
    context.verifyusernameAndemail = function (request) {
      return $.ajax({
        url: "https://casync.connectolive.com/verify/email",
        type: "POST",
        // dataType: "json",
        data: JSON.stringify(request),
        contentType: "application/json; charset=utf-8",
        success: function (response) {
          if (response) {
            var data = response.Data;
          }
        },
        error: function (error) {
        }
      });
    };
    context.GetCustomerInfoByEmail = function(email){
      return $.ajax({
        url: "https://casync.connectolive.com/verify/customersEmail/" + email,
        type: "GET",
        dataType: "json",
        contentType: "application/json; charset=utf-8"
      })
    }
    context.verifyEmailExists = function (email) {
      return $.ajax({
        url: context.endpoint["Customer"]["VerifyEmailExists"] + "?email=" + email,
        type: "GET",
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function (response) {
          if (response) {
            var data = response.Data;
          }
        },
        error: function (error) {
        }
      });
    };
    context.VerifyPhoneExists = function (phone) {
      return $.ajax({
        url: context.endpoint["Customer"]["VerifyPhoneExists"] + "?phone=" + phone,
        type: "GET",
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function (response) {
          if (response) {
            var data = response.Data;
          }
        },
        error: function (error) {
        }
      });
    };
    context.verifyssn = function (ssn) {
      return $.ajax({
        url: context.endpoint["Customer"]["ValidateTaxId"] + "?id=" + ssn,
        type: "GET",
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: function (response) {
          if (response) {
            var data = response.Data;
          }
        },
        error: function (error) {
        }
      });
    };
    context.PlaceOrder = function (request) {
      return $.ajax({
        url: context.endpoint["Enrollment"]["SubmitApplication"],
        type: "POST",
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify(request)
      });
    };
    context.createCheckoutID = function (request) {
      return $.ajax({
        url: 'https://casync.connectolive.com/enrollment/createCheckout',
        type: "POST",
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify(request)
      });
    };
    context.GetShippingMethods = function (request) {
      return $.ajax({
        url: context.endpoint["Enrollment"]["GetShippingMethods"],
        type: "POST",
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify(request)
      });
    };
    context.GetShopifyCustomer = function (request) {
      return $.ajax({
        url: context.endpoint["Enrollment"]["GetShopifyCustomer"],
        type: "POST",
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify(request)
      });
    };
    context.updateEmailtoCheckout = function (request) {
      return $.ajax({
        url: 'https://casync.connectolive.com/enrollment/updateEmail',
        type: "POST",
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify(request)
      });
    };

  context.updateCheckoutAttributes = function (request) {
    return $.ajax({
      url: 'https://casync.connectolive.com/enrollment/updateAttributes',
      type: "POST",
      contentType: "application/json; charset=utf-8",
      data: JSON.stringify(request),
      success: function (response) {
        console.log("Checkout attributes updated successfully", response);
      },
      error: function (error) {
        console.error("Failed to update checkout attributes", error);
      }
    });
  };
    
    context.saveCustomFields = function (request) {
      return $.ajax({
        url: 'https://syncenrollment.connectolive.com/fields',
        type: "POST",
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify(request)
      });
    };
    context.calculateShippingTotal = function (request) {
      return $.ajax({
        url: context.endpoint["Enrollment"]["calculateShippingTotal"],
        type: "POST",
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify(request)
      });
    };
    context.GetProduct = function (productid) {
      return $.ajax({
        url: context.endpoint["Enrollment"]["GetProduct"] + `?productid=${productid}`,
        type: "POST",
        contentType: "application/json; charset=utf-8",
      });
    };
    context.customerCreate = function (request) {
      return $.ajax({
        url: context.endpoint["Enrollment"]["customerCreate"],
        type: "POST",
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify(request)
      });
    };


    // ****************************
    // ****************************
    // ****************************
    // ****************************
    // ****************************
    // ****************************
    // ****************************
    // ****************************


    context.getpaymentType = function (request) {
      return $.ajax({
        url: context.endpoint["Payment"]["GetPaymentType"],
        type: "GET",
        dataType: "json",
        data: request,
        contentType: "application/json; charset=utf-8",
        success: function (response) {
          if (response) {
            var data = response.Data;
          }
        },
        error: function (error) {
        }
      });
    };
    context.getPaymentData = function (paymentData) {
      return $.ajax({
        url: context.endpoint['Payment']['GetHostedPaymentData'] + '?iframeId=dsIframe&merchantId=' + paymentData + '&countryCode=US&stateCode=AL',
        method: "Get",
        contentType: "application/json; charset=utf-8",
        async: true,
        success: function (response, request, trigger) {
          try {
            console.log('asdasasd');
            // openiframe(response.Data);
          } catch (e) {
            //LoaderRemoveconsole.error("Fetching available shipping methods failed! " + e);
          }
        }
      });
    };
    context.calculateorder = function (request) {
      // button.classList.add("st-bds_loading");
      var calculatrOrderRequest = {
        "Address1": request.Address1 ?? "",
        "Address2": request.Address2 ?? "",
        "Address3": request.Address3 ?? "",
        "City": request.City ?? "",
        "Country": request.Country ?? "US",
        "CouponCodes": request.CouponCodes ?? [],
        "CurrencyCode": request.CurrencyCode ?? "USD",
        "ShipMethodID": request.ShipMethodID ?? 0,
        "StoreID": request.StoreID ?? 3,
        "PriceTypeID": request.PriceTypeID ?? 2,
        "CustomerId": request.CustomerId ?? 0,
        "CustomerType": request.CustomerType ?? 2,
        "Details": request.Details ?? [],
        "OrderType": request.OrderType ?? 1,
        "State": request.State ?? "",
        "Zip": request.Zip ?? "",
        "Language": request.Language ?? "",
      };

      return $.ajax({
        url: 'http://shopifyapi.cloveritservices.com/api/siorder/calculateorder?order=true',
        method: "post",
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify(calculatrOrderRequest)
      });
    };
    context.calculateautoorder = function (request) {
      // button.classList.add("st-bds_loading");
      var calculateAutoOrderRequest = {
        "Address1": request.Address1 ?? "",
        "Address2": request.Address2 ?? "",
        "Address3": request.Address3 ?? "",
        "City": request.City ?? "",
        "Country": request.Country ?? "US",
        "CouponCodes": request.CouponCodes ?? [],
        "CurrencyCode": request.CurrencyCode ?? "USD",
        "ShipMethodID": request.ShipMethodID ?? 0,
        "StoreID": request.StoreID ?? 3,
        "PriceTypeID": request.PriceTypeID ?? 2,
        "CustomerId": request.CustomerId ?? 0,
        "CustomerType": request.CustomerType ?? 2,
        "Details": request.Details ?? [],
        "OrderType": request.OrderType ?? 2,
        "State": request.State ?? "",
        "Zip": request.Zip ?? "",
        "Language": request.Language ?? "",
      };

      return $.ajax({
        url: 'http://shopifyapi.cloveritservices.com/api/siorder/calculateorder?order=false',
        method: "post",
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify(calculateAutoOrderRequest)
      });
    };
    return this;
  }

  var DIEnrollmentInstance = new DIEnrollment();
  window.DIMainInstance.injectReference(DIEnrollmentInstance.name, DIEnrollmentInstance);
  DIEnrollmentInstance.init();
  function runExternalScripts(urlArray, deferred) {
    deferred = deferred || $.Deferred();

    var firstScript = urlArray.splice(0, 1)[0];

    if (!firstScript) {
      deferred.resolve();
      return deferred.promise();
    }

    $.getScript(firstScript).done(function () {
      runExternalScripts(urlArray, deferred).then(deferred.resolve, deferred.reject);
    });

    return deferred.promise();
  }
  function getExternalScripts(html) {
    var externalScriptOpenRegex = /<script[^>]*src="[^"]*"[^>]*>/g;
    var srcAttrRegex = /src="([^"]*)"/;

    var scriptTags = html.match(externalScriptOpenRegex);

    if (!scriptTags) {
      return [];
    }

    return scriptTags.map(function (tag) {
      var link = srcAttrRegex.exec(tag);

      if (!link) {
        return null;
      }

      // Index 1 is the first capture group result
      return link[1];
    }).filter(function (link) {
      return !!link;
    });
  }

  function getInlineScripts(html) {
    var inlineScriptTagRegex = /<script[^>]*>([\s\S]*)<\/script>/g;
    var scriptTags = html.match(inlineScriptTagRegex);

    if (!scriptTags) {
      return [];
    }

    return scriptTags.map(function (tag) {
      var script = inlineScriptTagRegex.exec(tag);

      if (!script) {
        return null;
      }

      // Index 1 is the first capture group result
      return script[1];
    }).filter(function (script) {
      return !!script;
    });
  }

  function removeExternalScriptTags(html) {
    var externalScriptRegex = /<script[^>]*src="[^"]*"[^>]*>.*<\/script>/g;
    return html.replace(externalScriptRegex, '');
  }



  function runInlineScripts(scriptArray) {
    window.eval(scriptArray.join('\n;\n'));
    if (typeof onload !== 'undefined' && typeof onload == 'function') { onload(); }
  }
  function executePaymentScripts(html) {
    // Extract, load and execute <script src> tags
    // Extract and execute <script> tags with inline javascript

    var externalScripts = getExternalScripts(html);
    html = removeExternalScriptTags(html);

    runExternalScripts(externalScripts).then(function () {
      var inlineScripts = getInlineScripts(html);
      runInlineScripts(inlineScripts);
    });
  }

  function setUpIframeMethods() {
    window.OnIFrameError = function (error) {
      if (!error) {
        return;
      }
      window.DI.DI.notification('Error', "Error In Creating Payment" + error, 'error');
    };

    window.OnIFrameSave = function (data) {
      window.DI.DI.notification('Success', "Payment Added Successfuly", 'success');
    };
  }
  function openiframe(data) {
    window.AssociateID = data.AssociateID;
    window.OnIFrameSave = null;
    window.OnIFrameError = null;
    setUpIframeMethods();
    executePaymentScripts(data.Head);
  }
})();